import { type ElementRef, forwardRef } from 'react';

import { Box, BoxProps } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';

const summaryCardStyles = css.raw({
  bg: 'background.surface',
  borderRadius: 'medium',
  px: 'space.300',
  boxShadow: '0px 1px 0px token(colors.border.weak)',
});

const SummaryCard = forwardRef<ElementRef<'div'>, BoxProps>(({ children, css: cssProp, ...props }, forwardedRef) => {
  return (
    <Box ref={forwardedRef} css={css.raw(summaryCardStyles, cssProp)} {...props}>
      {children}
    </Box>
  );
});

SummaryCard.displayName = 'SummaryCard';

export default SummaryCard;
